import type { ResultsTabId } from "app/pages/sales-intelligence/modules/leads-search/types";
import type { StateParamsDeclaration } from "app/pages/sales-intelligence/types/routing";

export type PageRoutingParams = {
    pageSection: ResultsTabId | null;
    isShowWalkThrough?: boolean;
    /** Requests entry into a demo on arrival. See `demo` in {@link pageParams} for why it is not a URL param. */
    demo?: string | null;
};

export const pageParams: StateParamsDeclaration<PageRoutingParams> = {
    pageSection: { type: "string", value: null, dynamic: true },
    isShowWalkThrough: { dynamic: true },
    /**
     * Deliberately absent from the state's `url`, so it is a transition-only param: it never reaches the
     * address bar and so never needs clearing, and a reload cannot replay a demo the user has since left.
     * `inherit: false` keeps it a one-shot command — without it the value would ride along to the next
     * transition within this state tree and re-trigger entry.
     */
    demo: { value: null, inherit: false },
};
